// extracted by css-extract-rspack-plugin
export default {"placeholderContainer":"omnibar-placeholder-module__placeholderContainer__Lmpy5","placeholderText":"omnibar-placeholder-module__placeholderText__EBhAq"};